import styled from '@emotion/styled';
import Button from '__components/Button';
import TableScrollContainer from '__components/Tables/ScrollContainer';

export const StyledTableScrollContainer = styled(TableScrollContainer)`
  & .BodyForSync {
    flex-direction: column;
  }
`;

export const TextCell = styled.div`
  font-size: 14px;
  line-height: 100%;
`;

export const StyledAddButton = styled(Button)`
  && {
    margin: 0;
    margin-top: 3px;
    padding: 0;
    height: 12px;
  }
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  gap: 20px;
`;
